module.exports = {
  ApiBlog: {
    // url: 'https://www.diogocezar.com/wp-json/wp/v2/',
    url: 'https://nextjs-rouge-alpha.vercel.app/api',
  },
  ApiContact: {
    url: 'https://us-central1-dctb-firebase.cloudfunctions.net/sendMail',
  },
}
